import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import DropdownMenu from './DropdownMenu';
import DropdownMenuItem from './DropdownMenuItem';

const CustomDropDown = ({
  onChange,
  selectedOption,
  dropdownList,
  ...rest
}) => {
  console.log('dropdownList', dropdownList, selectedOption);
  const [searchText, setSearchText] = useState('');
  const textInput = useRef(null);
  const [filteredDropdownList, setFilteredDropdownList] = useState(
    dropdownList,
  );

  useEffect(() => {
    setFilteredDropdownList(
      dropdownList.filter((item) => item.name.toLowerCase().includes(searchText.toLowerCase())),
    );
  }, [searchText, dropdownList]);
  return (
    <DropdownMenu {...rest} searchref={textInput}>
      <div className="search-box">
        <div className="input-holder">
          <input
            type="text"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="location-search"
            ref={textInput}
          />
          <i className="material-icons">search</i>
        </div>
      </div>
      {/* eslint react/no-array-index-key: "off" */
      filteredDropdownList.map((item, index) => {
        return (
          <DropdownMenuItem
            label={item.name}
            key={index}
            value={item.id}
            onClick={onChange}
            type="BUTTON"
            className={classnames(item.className, {
              active:
                selectedOption === item.id ||
                (item.name === 'All' && typeof selectedOption === 'object'),
            })}
          />
        );
      })
      }
    </DropdownMenu>
  );
};

export default CustomDropDown;
